// A/R basis: billed charges for most practices; at allowed for a practice whose payers
// allow under half of billed (backend ar_allowed_service). The pages that print A/R
// (the A/R page, Customer Success, the Weekly Ledger Review) read the basis object the
// backend sends ({basis, allowed_to_billed, paid_claims, window_days, threshold}) and
// print this one sentence as their data-quality line.

export function isAllowedBasis(arBasis) {
  return Boolean(arBasis && arBasis.basis === 'allowed');
}

// "A/R at allowed: paid claims allowed 23% of billed (40 claims, last 180 days), under 50%."
// "A/R at billed: paid claims allowed 72% of billed (40 claims, last 180 days)."
// "A/R at billed: too few paid claims in the last 180 days to measure allowed to billed."
export function arBasisLine(arBasis) {
  if (!arBasis) return null;
  const days = arBasis.window_days || 180;
  const ratio = arBasis.allowed_to_billed;
  if (ratio === null || ratio === undefined) {
    return `A/R at billed: too few paid claims in the last ${days} days to measure allowed to billed.`;
  }
  const pct = `${Math.round(Number(ratio) * 100)}%`;
  const claims = Number(arBasis.paid_claims || 0).toLocaleString('en-US');
  const threshold = `${Math.round(Number(arBasis.threshold || 0.5) * 100)}%`;
  const measured = `paid claims allowed ${pct} of billed (${claims} claims, last ${days} days)`;
  return isAllowedBasis(arBasis)
    ? `A/R at allowed: ${measured}, under ${threshold}.`
    : `A/R at billed: ${measured}.`;
}
